import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildingBlock16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconBuildingBlock16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 3h-1a.5.5 0 0 0-.5.5V4h2v-.5a.5.5 0 0 0-.5-.5M3 3.5V4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2v-.5A1.5 1.5 0 0 0 11.5 2h-1A1.5 1.5 0 0 0 9 3.5V4H7v-.5A1.5 1.5 0 0 0 5.5 2h-1A1.5 1.5 0 0 0 3 3.5m7 .5h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM9 5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBuildingBlock16);
